import React from 'react';
import { Stack, Divider } from '@mui/material';

interface IProps {
  children: React.ReactNode;
}

const ColumnView = ({ children }: IProps) => {
  return (
    <Stack
      sx={{ justifyContent: 'space-between' }}
      direction='row'
      divider={<Divider orientation='vertical' flexItem />}
    >
      {children}
    </Stack>
  );
};

export default ColumnView;
